<template>
  <div class="flex flex-col mb-4 pt-4">
    <div class="text-2xl my-4 font-bold">
      {{ LL.article_by_the_same_author() }}
    </div>
    <CommonLoadingCard v-if="isLoading" />
    <template v-else>
      <div v-if="posts.length > 0" class="grid grid-cols-12 gap-3">
        <PostCardFooter v-for="post in posts" :key="post.id" :post="post" />
      </div>
      <LazyEmpty v-else :description="LL.there_are_no_posts_yet()" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { TSuggestPostResponse, TSuggestPost } from "features/course";
import { typesafeI18n } from "~/locales/i18n-vue";
const { params } = useRoute();
const config = useRuntimeConfig();

const { LL } = typesafeI18n();

const posts = reactive<TSuggestPost[]>([]);
const isLoading = ref<boolean>(true);

onMounted(async () => {
  const result: TSuggestPostResponse = await $fetch(
    `${config.public.apiBase}/api/posts/the-same-author/${params.slug}`
  );
  isLoading.value = false;

  posts.push(...result.data);
});
</script>
